module.exports = __webpack_public_path__ + "img/BA.0b100d6c.svg";